/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { AbstractRestService, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';

import { AuthNumberDto } from './auth-numbers.dto';
import { AuthNumbersMapper } from './auth-numbers.mapper';

@Injectable()
export class AuthNumberRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  generate(authRequest: AuthNumberDto): Observable<AuthNumberDto> {
    return this.httpPost(`${this.bp}/auth-numbers/generate`, authRequest, AuthNumbersMapper);
  }

  getSource(authRequest: AuthNumberDto): Observable<AuthNumberDto> {
    return this.httpPost(`${this.bp}/auth-numbers/source`, authRequest, AuthNumbersMapper);
  }

  validate(authRequest: AuthNumberDto): Observable<AuthNumberDto> {
    return this.httpPost(`${this.bp}/auth-numbers/validate`, authRequest, AuthNumbersMapper);
  }
}
